document.addEventListener("DOMContentLoaded", searchTabsInit, false);
document.addEventListener("shopify:section:load", searchTabsInit, false);
document.addEventListener("DOMContentLoaded", speechInit, false);
document.addEventListener("shopify:section:load", speechInit, false);
var $resultsBox = $('.yv-search-result-container');
var searchbarresult=$('body').find('.yv-header-searchbar-content');

function removeHtmlEntities(str) {
    const htmlEntities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;"
    };
    return str.replace(/([&<>\"'])/g, match => htmlEntities[match]);
}

function searchTabsInit() {
    var tabHead = document.getElementsByClassName('yv-tab-result-head');
    if (tabHead.length > 0) {
        var tabContent = document.getElementsByClassName('yv-search-result-list');
        Array.from(tabHead).forEach(function(btn) {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                Array.from(tabHead).forEach(function(item) {
                item.classList.remove('active');
                });
                let searchUrl = btn.getAttribute("data-resulturl");
                let searchContainer = document.querySelector('.search-bar-container');
                if (searchContainer) {
                    let allresultLink = searchContainer.querySelector('.search-result-bottom');
                    if (searchContainer) {
                        allresultLink.setAttribute('href', searchUrl);
                    }
                }
                Array.from(tabContent).forEach(function(item) {
                    item.classList.remove('active');
                });
                btn.classList.add("active");
                var _value = btn.getAttribute("data-results");
                document.getElementById(_value).classList.add("active");
            });
        });
    }
}

var searchTyping;
var searchRequestVersion = 0;
var searchAbortController;
function invalidateSearchRequests() {
    clearTimeout(searchTyping);
    searchRequestVersion++;
    if (searchAbortController) searchAbortController.abort();
}
function closeSearchDrawer(restoreFocus) {
    invalidateSearchRequests();
    $('a.search-form[data-search-drawer]').attr('aria-expanded', 'false');
    $('body').removeClass('addsearch');
    if (restoreFocus) {
        stopFocusElementsRotation();
        if (focusElement && typeof focusElement.trigger === 'function') focusElement.trigger('focus');
    }
}
function readRecentSearch() {
    try {
        const value = JSON.parse(localStorage.getItem('Recent_search'));
        return Array.isArray(value) ? value : null;
    } catch (_) { return null; }
}
$(document).ready(function() {
    $('body').on('click','a.search-form[data-search-drawer]',function(e) {
        e.preventDefault();
        focusElement = $(this);
        var _class = $(this).data('search-drawer');
        $('body').addClass(_class);
        $('.search-bar-container input.search-input').trigger('focus');
        $(this).attr({ 'aria-expanded': 'true', 'aria-controls': 'rsd-search-drawer' });
        $('#recent_search_list').html('');
        recentSearch();
        var queryInput = $('.search-bar-container input[name="q"]');
        if (queryInput.val().trim()) searchResults(queryInput);
        focusElementsRotation($('.search-bar-container'));
    });
    /// AjaX Product Search
    $('.AjaxSearchResponse').prepend('');
    $('.search-close').show();
    $('body').on('keydown', '.search-input', function(e) {
        clearTimeout(searchTyping);
       if (this.value.length === 0 && e.which === 32) e.preventDefault();
    });
    $('body').on('input', '.search-input', function(e) {
        clearTimeout(searchTyping);
        var _this = $(this);
        searchResults(_this)
    })

    $('body').on('click', '.yv-search-drawer-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeSearchDrawer(true);
    });
    $('body').on('submit', 'form[role="search"]', function() {
        closeSearchDrawer(false);
    });

  $('body').on('click', '.yv-search-bar', function(e) {
    if($(this).val().length > 2){
        $('.yv-header-searchbar-content').show();
    }
  })

   $(document).on("click","button[data-searchbar-cross]",function(e) {
     e.preventDefault();
     invalidateSearchRequests();
     $(this).hide();
     $(".yv-search-bar").val("");
     searchbarresult.hide();
      searchbarresult.html("");
   })
    // search ends
});


function recentSearch() {
    const requestVersion = searchRequestVersion;
    const list = $('#recent_search_list');
    list.empty();
    const handles = (readRecentSearch() || []).slice(-10).reverse().filter(value => typeof value === 'string' && /^[a-zA-Z0-9-]+$/.test(value));
    if (!handles.length) {
        list.siblings('.yv-search-result-container').addClass('no-recent');
        return;
    }
    list.siblings('.yv-search-result-container').removeClass('no-recent');
    const productUrl = rootUrl.length > 1 ? rootUrl : '';
    const requests = handles.map(handle => new Promise(resolve => {
        jQuery.ajax({
            type: 'GET', url: productUrl + '/products/' + encodeURIComponent(handle) + '.json', timeout: 10000,
            success: response => resolve(response.product), error: () => resolve(null)
        });
    }));
    Promise.all(requests).then(products => {
        if (requestVersion !== searchRequestVersion || !$('body').hasClass('addsearch')) return;
        const items = products.filter(Boolean).map(product => {
            const item = $('<li>');
            const link = $('<a>').addClass('focus-inside').attr('href', productUrl + '/products/' + product.handle);
            if (product.image) $('<img>').attr({ src: product.image.src + '&width=100', alt: product.title }).appendTo(link);
            $('<span>').text(product.title).appendTo(link);
            return item.append(link);
        });
        if (items.length) {
            list.append($('<h6>').addClass('recent-search-title').text(searchRecentTitleText));
            list.append($('<ul>').addClass('list-unstyled recent-search-listing').append(items));
            focusElementsRotation($('.search-bar-container'));
        }
    });
}

function searchResults(inputField){
    const requestVersion = ++searchRequestVersion;
    var section_id='';
    var _drawer = $('[data-search-drawer]').data('search-drawer');
    var _searchContainer = $('body').find('.search-bar-container');
    var retrievedSearch_v = readRecentSearch();
    if (retrievedSearch_v == null) {
        var retrievedSearch_v = [];
    }
    var $form = inputField.closest('form');
    searchTyping = setTimeout(function() {
        $resultsBox.html(preLoadLoadGif);  
        var term = $form.find('input[name="q"]').val();     
        if (!term.trim()) { $resultsBox.empty(); searchbarresult.empty().hide(); return; }
        var resultType = 'product';
        if (searchPageResults) {
            resultType += ',page'
        }
        if (searchArticleResults) {
            resultType += ',article'
        }
        if (searchCollectionResults) {
            resultType += ',collection'
        }
        if (searchSuggestions) {
            resultType += ',query'
        }
      if(inputField.hasClass("yv-search-bar")){
        searchbarresult.show();
        searchbarresult.html(preLoadLoadGif);
        section_id='predictive-search-lite';       
      }else{
          section_id='predictive-search';
      }
        if (term != inputField.data('oldval')) {
            if((term.trim() == '') && ($(searchbarresult).closest('.yv-header-searchbar-box').length)){
                searchbarresult.hide();
            }
           if(inputField.hasClass("yv-search-bar")){
              $("button[data-searchbar-cross]").show();
           }
            const controller = new AbortController();
            if (searchAbortController) searchAbortController.abort();
            searchAbortController = controller;
            const deadline = setTimeout(() => controller.abort(), 10000);
            fetch(searchUrl+"/suggest?section_id="+ section_id +"&q=" + encodeURIComponent(term) + "&resources[type]=" + resultType + "&resources[options][fields]=author,tag,title,product_type,variants.title,vendor,variants.sku", { signal: controller.signal })
            .then((response) => { if (!response.ok) throw new Error('Search unavailable'); return response.text(); })
            .then((resultHtml) => {
                if (requestVersion !== searchRequestVersion || $form.find('input[name="q"]').val() !== term) return;
                if (!inputField.hasClass('yv-search-bar') && !$('body').hasClass('addsearch')) return;
                let results = new DOMParser().parseFromString(resultHtml, 'text/html').querySelector('#shopify-section-'+section_id);
                if(inputField.hasClass("yv-search-bar")){
                    if(results){
                        searchbarresult.html(results.innerHTML)
                    }
                }else{
                    if(_searchContainer.find('[data-search-suggestions]').length > 0){
                        if(results && results.querySelector('[data-search-suggestions]')){
                            _searchContainer.find('[data-search-suggestions]').html(results.querySelector('[data-search-suggestions]').innerHTML)
                            results.querySelector('[data-search-suggestions]').innerHTML = '';
                        }else{
                        _searchContainer.find('[data-search-suggestions]').html('')
                        }                          
                    }
                if(results){
                    $resultsBox.html(results.innerHTML);
                    searchTabsInit();
                    if ((typeof recentProductHandle != 'undefined') && retrievedSearch_v.includes(recentProductHandle) === false) {
                        retrievedSearch_v.push(recentProductHandle);
                    }
                    try { localStorage.setItem("Recent_search", JSON.stringify(retrievedSearch_v)); } catch (_) {}
                }
                else{
                    $resultsBox.empty();
                }
                    focusElementsRotation($('.search-bar-container'));
                }                    
            })
            .catch(() => {
                if (requestVersion !== searchRequestVersion || $form.find('input[name="q"]').val() !== term) return;
                if (!inputField.hasClass('yv-search-bar') && !$('body').hasClass('addsearch')) return;
                const fallback = document.createElement('a');
                fallback.href = searchUrl + '?' + new URLSearchParams({ q: term, type: 'product', 'options[prefix]': 'last' });
                fallback.textContent = searchAllResultText;
                const target = inputField.hasClass('yv-search-bar') ? searchbarresult : $resultsBox;
                target.empty().append(fallback).show();
            })
            .finally(() => clearTimeout(deadline));
        } else if (term.length <= 2) {
            $resultsBox.empty();
            searchbarresult.empty();
           $("button[data-searchbar-cross]").hide();
           searchbarresult.css("display","none")
            focusElementsRotation($('.search-bar-container'));
        }
    }, 1000);
}

function speechInit() {
    let searchBySpeechs = document.querySelectorAll("[data-speech-search]");
    Array.from(searchBySpeechs).forEach(function (searchBySpeech) {
        initSpeectRecognition(searchBySpeech);
    });
}
function initSpeectRecognition(searchSpeech) {
    let speechRecognition = null;
    let listening = false;
    let searchInput = null;
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
        "webkitSpeechRecognition" in window &&
        userAgent.indexOf("chrome") > -1 &&
        !!window.chrome &&
        userAgent.indexOf("edg/") === -1
    ) {
        searchSpeech.classList.remove("hidden");
        speechRecognition = new window.webkitSpeechRecognition();
        speechRecognition.continuous = false;
        speechRecognition.interimResults = false;
        searchInput = searchSpeech
            .closest("form")
            .querySelector("[data-search-input]");
        speechRecognition.addEventListener(
            "result",
            debounce((evt) => {
                if (evt.results) {
                    const term = evt.results[0][0].transcript;
                    searchInput.value = term;
                    searchInput.focus();
                    searchInput.dispatchEvent(new Event("input"));
                    searchResults($(searchInput))
                }
            }, 300)
        );
        speechRecognition.addEventListener("audiostart", () => {
            listening = true;
            searchSpeech.classList.add("active");
        });
        speechRecognition.addEventListener("audioend", () => {
            listening = false;
            searchSpeech.classList.remove("active");
        });
        searchSpeech.addEventListener("click", function (evt) {
            evt.preventDefault();
            if (listening) {
                speechRecognition.stop();
                listening = false;
            } else {
                speechRecognition.start();
                listening = true;
            }
        });
        searchSpeech.addEventListener("keydown", (evt) => {
            if (evt.code === "Space" || evt.code === "Enter") {
                evt.preventDefault();
                if (listening) {
                    speechRecognition.stop();
                } else {
                    speechRecognition.start();
                }
            }
        });
    }
}
